import { get } from 'lodash';
import { useTypedQuery } from '../helpers/useTypedQuery';

export const useUserMe = (enabled: boolean = false) => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/users/me', {
    queryOpts: {
      enabled: enabled
    }
  });

  return {
    isLoading,
    refetch,
    user: {
      id: get(data, 'id', null),
      firstname: get(data, 'first_name', ''),
      lastname: get(data, 'last_name', ''),
      email: get(data, 'email', ''),
      phone: get(data, 'phone', ''),
      administrator: get(data, 'is_administrator', ''),
      job: get(data, 'position', ''),
      positionTitle: get(data, 'position_title', null),
      linkedin: get(data, 'linkedin_profile', ''),
      currency: get(data, 'currency_displayed'),
      language: get(data, 'language', 'en'),
      newsletter: get(data, 'is_newsletter_activated', false),
      newsletterHour: get(data, 'newsletter_hour', 0),
      isBranded: get(data, 'client.marque_analysis', false),
      services: get(data, 'services', []),
      client: {
        id: get(data, 'client.id', null),
        displayWineshops: get(data, 'client.display_wineshops', false),
        email: get(data, 'client.email', ''),
        label: get(data, 'client.label', ''),
        language: get(data, 'client.language', 'en'),
        marqueAnalysis: get(data, 'client.marque_analysis', false),
        timezone: get(data, 'client.time_zone'),
        subscribed: get(data, 'client.subscribed', ''),
        tags: get(data, 'client.tags_names', []),
        wxrPanels: get(data, 'client.wxr_panels', []),
        users: get(data, 'client.users', [])
      }
    }
  };
};

export const usePositions = () => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/users/positions');

  return {
    isLoading,
    refetch,
    positions: data || []
  };
};

export const useUserServices = () => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/users/services');

  return {
    isLoading,
    refetch,
    services: data || []
  };
};
